module.exports = __webpack_public_path__ + "img/empty-195 (1).d41d8cd9.svg";